import { render, staticRenderFns } from "./ReturnHistory.vue?vue&type=template&id=13885692&"
import script from "./ReturnHistory.vue?vue&type=script&lang=js&"
export * from "./ReturnHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports